import { render, staticRenderFns } from "./NewOrderDetail.vue?vue&type=template&id=5c14cca0&"
import script from "./NewOrderDetail.vue?vue&type=script&lang=js&"
export * from "./NewOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports